import React from "react";

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="hero-container">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>Bem-vindo ao Amarante PetShop</h1>
        <p>Cuidado completo para o seu pet em São Gonçalo do Amarante</p>
        <div className="hero-buttons">
          <a
            href="https://wa.me/5584988654827"
            className="hero-button whatsapp-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp"
              width="24"
              height="24"
            />
            Fale conosco no WhatsApp
          </a>
          <button
            className="hero-button scroll-button"
            onClick={() => scrollToSection("about")}
          >
            Saiba Mais
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
